export default __webpack_public_path__ + "static/part3-sketch-be8820016fea03eae7631e5783cedeb7.jpg";